export const environment = {
  production: true,
  SOCKET_ENDPOINT: "https://www.mensasur.es",
};
